module.exports = __webpack_public_path__ + "img/replay.675ce656.png";